module.exports = __webpack_public_path__ + "img/iphone-map-SWEDEN-en.89a6727b.png";